<template>
  <block :title="title">
    <a slot="actions" class="link-button"><img src="../assets/images/dots.png"></a>
    <div class="info-list" style="height: 360px;">
      <div v-for="item in data" :key="item.id" class="info-list-item">
        <div class="info-list-item-dot"></div>
        <div class="info-list-field">
          <a v-if="title==='最新开业场馆'" class="link" :href="$router.resolve({path:'/changguan/details',query:{id:item.id}}).href">{{ item.mc }}</a>
          <div v-else>{{ item.mc }}</div>
        </div>
        <div class="info-list-field info-list-field-fixed" style="width: 60px">{{ item.province }}</div>
        <div class="info-list-field info-list-field-fixed" style="width: 100px;" v-if="title==='最新开业场馆'">{{ item.kysj }}</div>
      </div>
    </div>
  </block>
</template>

<script>
import api from "../api";
import Block from "./Block";

export default {
  name: "ChangguanListBlock",
  components: {Block},
  props:{
    title:String
  },
  data() {
    return {
      data: [],
      sorceData:[
        {mc:"合肥新站会展中心", province:"安徽"},
        {mc:"乐山冠英国际会展中心", province:"四川"},
        {mc:"萍乡市会展中心", province:"江西"},
        {mc:"上饶国际会展中心", province:"江西"},
        {mc:"深圳国际会展中心二期", province:"广东"},
        {mc:"鹰潭市会展中心", province:"江西"},
        {mc:"佛山西站枢纽新城会展中心", province:"广东"},
        {mc:"赣州会展中心", province:"江西"},
        {mc:"杭州大会展中心（一期）", province:"浙江"},
        {mc:"呼伦贝尔国际会展中心", province:"内蒙古"},
      ]
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const params = {
        page: 0,
        size: 10,
      }
      if(this.title==='最新开业场馆'){
        params.sort='kysj,DESC'
        this.data = (await api.listChangguan(params)).data.content
      }else{
        params.sort='id,DESC'
        this.data = this.sorceData
      }
    }
  }
}
</script>

<style scoped>

</style>
